import Headroom from "headroom.js";

// Initialize headroom
const myHeader = document.querySelector(".contyquim-header");
var options = {
    tolerance: {
        up: 0,
        down: 15
    }
};
const headerHeadroom = new Headroom(myHeader, options);
headerHeadroom.init();

function freezeNav(){
    headerHeadroom.freeze();
}

function unfreezeNav(){
    headerHeadroom.unfreeze();
}

// Set header spacer height on load and on page resize
const headerSpacer = document.querySelector(".header-spacing");
setHeaderSpacerHeight(myHeader.offsetHeight);

window.onresize = () => {
    setHeaderSpacerHeight(myHeader.offsetHeight);
}

function setHeaderSpacerHeight(height) {
    headerSpacer.style.height = `${height}px`;
}

// Handle hamburger button
/*
const hambuergerBtn = document.querySelector(".hamburger");
hambuergerBtn.onclick = () => {
    hambuergerBtn.classList.toggle("is-active");
}
*/
// Search form
// const searchFormTriggers = document.querySelectorAll(".searchForm-trigger");
// searchFormTriggers.forEach(searchFormTrigger => {
//     searchFormTrigger.onclick = e => {
//         e.preventDefault();
//         console.log()
//     }
// });

export {freezeNav, unfreezeNav};
  